import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
import { Input } from '../components/ui/Input';
export function EditPackage() {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  const isEdit = !!id;
  return <div className="space-y-4" data-id="element-764">
      <div className="flex items-center justify-between" data-id="element-765">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-766">
          {isEdit ? 'Edit Package' : 'Add Package'}
        </h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/packages')} data-id="element-767">
          ← Back to Packages
        </Button>
      </div>

      <Card data-id="element-768">
        <CardContent className="pt-6" data-id="element-769">
          <form className="space-y-4 max-w-md" data-id="element-770">
            <Input label="Name" defaultValue={isEdit ? 'Starter Bundle' : ''} data-id="element-771" />
            <div data-id="element-772">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-773">
                Package Types
              </label>
              <select className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 w-full" data-id="element-774">
                <option data-id="element-775">Generic Package</option>
                <option data-id="element-776">Preset package</option>
              </select>
            </div>
            <Input label="Total Courses" type="number" defaultValue={isEdit ? '3' : ''} data-id="element-777" />
            <Input label="Price" defaultValue={isEdit ? '99.00' : ''} data-id="element-778" />
            <Input label="Crossed Price" defaultValue={isEdit ? '149.00' : ''} data-id="element-779" />
            <Input label="Position" type="number" defaultValue={isEdit ? '1' : ''} data-id="element-780" />
            <div data-id="element-781">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-782">
                Publish
              </label>
              <select className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 w-24" data-id="element-783">
                <option data-id="element-784">Yes</option>
                <option data-id="element-785">No</option>
              </select>
            </div>
            <div className="pt-2" data-id="element-786">
              <Button type="submit" data-id="element-787">Submit</Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>;
}